export default __webpack_public_path__ + "static/media/ThePiano_06.e5fb175b.png";